import { Auth, base, getEnv } from '@/utils';

const { GO_ENDPOINT } = getEnv();

type PostUserCardV2Props = {
  userId: string;
  setup_intent: string;
  setup_intent_client_secret: string;
  redirect_status: string;
};

export const postUserCardV2 = async ({
  userId,
  ...params
}: PostUserCardV2Props) => {
  const token = await Auth.getIdToken();
  const response = await base.post(
    `${GO_ENDPOINT}/v1/users/${userId}/cards`,
    params,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};
